import axios from "axios";

/**
 * Base URL for planer server without trailing slash
 */
const BASE_SERVER = "https://demo-service.saliorel.cloud";
const Planer = {
  /**
   * Tasks actions
   */
  Tasks: {
    /**
     * Fetch a list of tasks from the server returning a Promise
     */
    fetch: () =>
      axios
        .get(`${BASE_SERVER}/agenda-tasks`, { withCredentials: true })
        .then(res => res.data),

    /**
     * Create the given task object on the server
     */
    createTask: task =>
      axios
        .post(
          `${BASE_SERVER}/agenda-tasks`,
          { ...task },
          { withCredentials: true }
        )
        .then(res => res.data),

    /**
     * Update a task with a given identifier to set its 'done' property
     */
    setTaskDone: (taskIdentifier, done) =>
      axios
        .put(
          `${BASE_SERVER}/agenda-tasks/${taskIdentifier}`,
          { done },
          { withCredentials: true }
        )
        .then(res => res.data),

    /**
     * Remove a specified task from the server.
     */
    removeTask: taskIdentifier =>
      axios
        .delete(`${BASE_SERVER}/agenda-tasks/${taskIdentifier}`, {
          withCredentials: true
        })
        .then(res => res.data)
  }
};

export default Planer;



// WEBPACK FOOTER //
// ./src/api/Planer.js